let URL = process.env.REACT_APP_API_URL;
let ASSET_URL = process.env.REACT_APP_ASSET_URL;
let socketUrl;

let apiPath = {
  baseURL: URL,
  socketUrl,
  assetURL: ASSET_URL,
  imageUrl: process.env.REACT_APP_IMAGE_URL,

  // Dashboard
  dashboard: "Dashboard",
  branchList: "admin/dashboard/branch-list",
  completedBookings: "admin/dashboard/completed-booking",
  activeUsers: "admin/dashboard/active-user",
  subscribeUsers: "admin/dashboard/subscribe-user",
  unSubscribeUsers: "admin/dashboard/unsubscribe-user",

  sendReport: "admin/booking/send-report",

  cancelBooking: "/admin/booking/cancel",

  amlTransaction: "AML/Transactions",
  // Customers
  customer: "students",


  parentsList: "admin/class/parents-list",
  studentsList: "admin/class/student-list",
  bookClasses: "admin/class/book-classes",


  // Auth API
  login: "AdminAuth/login",
  profile: "AdminAuth/GetAdminAllDetail",
  updateProfile: "AdminAuth/UpdateDetails",
  changePassword: "AdminAuth/ChangePassword",
  forgotPassword: "AdminAuth/ForgotPassword",
  verifyOTP: "AdminAuth/VerifyOTP",
  resetPassword: "AdminAuth/ResetPassword",

  // SubAdmin APIs
  subAdmin: "AdminAuth/GetAdminListings",
  subAdminDelete: "SubAdmin/Delete",
  subAdminStatus: "SubAdmin/status",
  add: "SubAdmin/Add",
  edit: "SubAdmin/edit",

  // Contract
  constracts: "Contract",

  // Static Content
  staticContent: "admin/static-content/view-content",
  editStatic: "admin/static-content/edit-content",

  // Commission
  commissionMaster: "CommissionMaster",

  // dispute APIs
  dispute: "DisputeManagement",

  // Content APIs
  content: "Pages",

  // EmailTemplate APIs
  emailTemplate: "EmailTemplate",
  addEditEmailTemplate: "EmailTemplate/update",
  viewEmailTemplate: "EmailTemplate",

  getAppSetting: "common/app-setting",
  notification: "admin/notification",
  transaction: "Transactions",

  common: {},
  settings: "SystemConfiguration",
};

export default apiPath;
